import React from "react";
import { Input, Label } from "reactstrap";

const CustomRadionButton = ({ name, id, label, onChange, defaultChecked }) => {
    return (
        <>
            <div className="form-check form-check-inline">
                <Input
                    type="radio"
                    onChange={onChange}
                    defaultChecked={defaultChecked}
                    name={name}
                    className="form-check-input"
                    id={id}
                />
                <Label
                    className="form-check-label"
                    htmlFor={id}
                >
                    {label}
                </Label>
            </div>&nbsp;
        </>
    )
}

export default CustomRadionButton;